<template>
  <div class="flex justify-between px-8 py-6">

    <div class="flex gap-4">
      <ResponsiveButton
        data-testid="my-calendar.right-calendar-header.settings-btn"
        button_type="text"
        built_in_theme="dark"
        size="medium"
        display_name="Settings"
        customized_class="settings-btn"
        @click-button="goToAvailability"
      >
        <template #prefix>
          <img src="@/assets/my-calendar/setting.svg" alt="setting" />
        </template>
      </ResponsiveButton>

      <ResponsiveButton
        data-testid="my-calendar.right-calendar-header.create-new-event-btn"
        button_type="filled"
        built_in_theme="dark"
        size="medium"
        display_name="Create New Event"
        customized_class="create-event-btn"
        @click-button="createNewEvent"
      >
        <template #prefix>
          <img src="@/assets/my-calendar/add.svg" alt="add" />
        </template>
      </ResponsiveButton>

    </div>
    
    <div class="flex">
      <div
        data-testid="my-calendar.right-calendar-header.calendar-tab"
        :class="['calendar-tab', { active: activeTab === 'calendar' }]"
        @click="switchTab('calendar')"
      >
      <img
        v-if="activeTab === 'calendar'"
        src="@/assets/my-calendar/calendar/white-calendar.svg"
        alt="switch-to-calendar"
      />
      <img
        v-else
        src="@/assets/my-calendar/calendar/calendar.svg"
        alt="switch-to-calendar"
      />
        <span>Switch to Calendar</span>
      </div>
      <div
        data-testid="my-calendar.right-calendar-header.task-tab"
        :class="['task-tab', { active: activeTab === 'task' }]"
        @click="switchTab('task')"
      >
        <span>Switch to Task</span>
        <img
          v-if="activeTab === 'task'"
          src="@/assets/my-calendar/white-alarm.svg"
          alt="switch-to-task"
        />
        <img
          v-else
          src="@/assets/my-calendar/alarm.svg"
          alt="switch-to-task"
        />
      </div>
    </div>
    
  </div>
</template>


<script setup>
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

const store = useStore();
const emit = defineEmits(['switch-tab', 'create-new-event']);
const activeTab = ref('calendar');
// const activeTab = ref('task');

// const isClinic150105 = computed(() => {
//   return store.state.login.userInfo?.clinic_id === 150105;
// });

const switchTab = (tab) => {
  activeTab.value = tab;
  emit('switch-tab', tab);
};

const router = useRouter();
const goToAvailability = () => {
  router.push('/my-calendar/availability');
}

const createNewEvent = () => {
  emit('create-new-event')
}
</script>

<style scoped>
.settings-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 2px 10px;
  background: #FFFFFF;
  border: none;
  border-radius: 23px;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.2px;
  color: #004879;
}

.settings-btn:hover {
  background: rgba(30, 70, 112, 0.08);
}

.settings-btn img {
  width: 24px;
  height: 24px;
}

.create-event-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 2px 10px;
  background: #004879;
  border: none;
  border-radius: 23px;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.2px;
  color: #FFFFFF;
}

.create-event-btn:hover {
  background: #1e4670;
}

.create-event-btn img {
  width: 24px;
  height: 24px;
}

.calendar-tab,
.task-tab{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 187px;
  gap: 10px;
  padding: 6px 14px;
  border: 1.3px solid #C9CACD;
  color:#374957;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  background: #FFFFFF;
}
.calendar-tab{ 
  border-radius: 35px 0 0 35px;
  border-right: none;
}
.task-tab {
  border-radius: 0 35px 35px 0;
  border-left: none;
}
.calendar-tab.active,
.task-tab.active {
  background: #5587BC; 
  color: #FFFFFF;
}
</style>